import { toNumber } from 'lodash'
import { formatCurrency, isValidAmount } from 'utils'

const currencyRegex = /[0-9-.]/g

const formatAndValidateCurrency = (input, inputField, record) => {
  const sanitizedInput = input.match(currencyRegex)?.join('')
  const amount = toNumber(sanitizedInput)
  if (isNaN(amount) || !isValidAmount(input)) {
    record.addError(inputField, 'Format must be: $X,XXX.XX')
    record.set(inputField, '$' + sanitizedInput)
  } else if (amount < 0) {
    record.addError(inputField, 'Amount cannot be negative')
    record.set(inputField, formatCurrency(amount))
  } else {
    record.set(inputField, formatCurrency(amount))
  }
  return
}

export default formatAndValidateCurrency
